import { RobotTwist } from "../api/robocore/dex_interfaces";
import { Vec3 } from "../models/SyntheticMap";

export abstract class BaseAnimator {
  public abstract render(delta: number): void;
  public getAnimations(): string[] {
    return [];
  }
  
  public playAnimation(name: string): void {
  }
  
  public walk(twist: RobotTwist = { linear: [1, 0, 0], angular: [0, 0, 0] }) {
  
  }

  public layDown() {

  }
  public standUp() {

  }

  public moveArm(pos:Vec3) {

  }
  
  public stop() {
  }
}

export class DefaultAnimator extends BaseAnimator {
  public render(delta: number): void {

  }
}